import { Button } from "@/components/button";
import { CatchPraise } from "@/components/catchPraise";
import { useDesignMaxTheme } from "@/packages";
import { COLORS } from "@/packages/theme/tokens";
import { useGetCommon, type AsideBannerResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Spinner } from "@chakra-ui/react";
import { type AsideBannerProps } from "./asideBanner.type";

export const AsideBanner = ({ isFullImg }: AsideBannerProps) => {
    const { data } = useGetCommon<AsideBannerResponse>({ section: "aside" });
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();
    const onLink = (url: string) => {
        window.open(url, "_blank");
    };

    const contentPCPaddingY = isLaptop ? "64px" : "120px";
    return data ? (
        <Box position="relative" zIndex="1">
            {isFullImg && (
                <Box
                    position="absolute"
                    w="100%"
                    h="100%"
                    opacity="1"
                    background={`url(${data.imgUrl}) no-repeat center/cover`}
                ></Box>
            )}
            <Box position="absolute" w="100%" h="100%" background="blackAlpha.400" />
            <Center
                position="relative"
                maxW={!isFullImg ? "100% !important" : "none"}
                flexDir="column"
                alignItems="center"
                paddingY={isMobile ? "40px" : contentPCPaddingY}
                rowGap="40px"
                sx={{
                    "& > div": {
                        display: "flex",
                        flexDir: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        rowGap: "40px",
                    },
                    "& div": {
                        display: "flex",
                        flexDir: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "0",
                        color: "white !important",
                    },
                    "& > div:first-of-type > p:first-of-type": {
                        ...FONT("cormorant", isMobile ? 16 : 54, 700, 1.2),
                    },
                    "& > div:first-of-type > p:last-of-type": {
                        ...FONT("notoSerif", isMobile ? 24 : 40, 300),
                    },
                    "& >button": {
                        border: `2px solid ${COLORS.white}`,
                        color: COLORS.white,
                        w: "164px",
                        h: isMobile ? "48px" : "54px",
                        borderRadius: "0",
                    },
                }}
            >
                <CatchPraise catchPraise={data.catchPraise} isDetail={false} />
                <Button size="medium" onClick={() => onLink(data.bookingUrl)}>
                    Reservation
                </Button>
            </Center>
        </Box>
    ) : (
        <Spinner />
    );
};
